export default __webpack_public_path__ + "static/media/16q.2a50ce36.png";